'use client';

import Modal from '@/app/components/Modal';
import { handleChatMenu } from '@/redux/reducers/chat-link-reducer';
import { cn } from '@/utils/cn';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function ChatMenuComponent() {
  const dispatch = useDispatch();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { openChatMenu } = useSelector((state) => state.chatLink);
  useEffect(() => {
    if (openChatMenu) {
      setIsOpenModal(true);
    } else {
      setIsOpenModal(false);
    }
  }, [openChatMenu]);

  const windowHandler = () => {
    dispatch(handleChatMenu());
  };

  return (
    <div
      className={cn(
        'chat-menu float w-full lg:w-[420px] sm:h-[264px] md:h-[276px] bottom-0 lg:right-[60px] lg:bottom-[60px] fixed z-[600] lg:z-[600]',
        {
          block: isOpenModal,
          hidden: !isOpenModal,
        },
      )}
    >
      <Modal
        type="chat-menu-modal"
        onView={isOpenModal}
        onClose={windowHandler}
        title="Hi There!"
      />
    </div>
  );
}

export default ChatMenuComponent;
